module.exports = __webpack_public_path__ + "static/media/seventhgen.ccd29d3f.png";